export class Config {
  public static config = {
    theme: 'horizontal', // default, collapse, horizontal
    themeType: 'dark' // default, dark, light
  };
}
